import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { HEADER_SMALL, LABEL_SMALL, LABEL_XS, PARAGRAPH } from 'Shared/styles/designConstants';
import styled from 'styled-components';

export const AccountHeroWrapper = styled.div`
  display       : flex;
  flex-direction: column;
  padding       : 24px 16px 16px 16px;
  border-radius : 16px;
  border        : 2px solid #EBEBEB;
  margin        : 16px;
`;

export const AccountHeroAvatarWrapper = styled.div`
  text-align: center;
  margin    : 0 auto 16px auto;
`;

export const AccountHeroAvatar = styled.p<{ colorScheme?: { avatarBg: string, avatarBorder: string } }>`
  ${HEADER_SMALL.DEFAULT};
  line-height     : 1;
  color           : ${DESIGN_TOKENS.color.primitive.white.value};
  width           : 54px;
  border-radius   : 50%;
  max-width       : 100%;
  aspect-ratio    : 1/1;
  display         : flex;
  align-items     : center;
  justify-content : center;
  border          : 2px solid ${props => props.colorScheme?.avatarBorder};
  background-color: ${props => props.colorScheme?.avatarBg};
`;

export const AccountHeroName = styled.h4`
  ${HEADER_SMALL.BOLD};
  text-align : center;
  line-height: 1;
`;

export const AccountHeroDate = styled.p`
  ${LABEL_XS.DEFAULT};
  color      : ${DESIGN_TOKENS.color.primitive.gray['700'].value};
  font-weight: 400;
  line-height: 1;
  text-align : center;
  margin-top : 8px;
`;

export const AccountHeroStats = styled.div`
  border-top   : 1px solid ${DESIGN_TOKENS.color.primitive.gray['400'].value};
  margin       : 16px 0 0 0;
`;

export const AccountHeroStatsListWrapper = styled.div`
  margin    : 16px 0 0 0;
  overflow  : hidden;
`;

export const AccountHeroStatsList = styled.ul`
  display       : flex;
  flex-direction: column;
  padding       : 0;
`;

export const AccountHeroStatsListItem = styled.li`
  color          : #282828;
  display        : flex;
  justify-content: space-between;
  align-items    : center;
  padding        : 8px 0;
`;

export const AccountHeroStatsListItemLabel = styled.span`
  ${LABEL_SMALL.DEFAULT};
  font-weight: 400;
  display    : flex;
  align-items: center;
  line-height: 1;
  column-gap : 12px;
`;

export const AccountHeroStatsListItemIcon = styled.img`
  width : 16px;
  height: 16px;
`;

export const AccountHeroStatsListItemValue = styled.span`
  ${PARAGRAPH.BOLD};
  line-height: 1;
`;
